<div class="db-create-sub-site__header">
  <h2 class="db-create-sub-site__title">Add new site to multisite network</h2>
</div>

<form class="db-create-sub-site__body" [formGroup]="subSiteForm" (ngSubmit)="addSubSite()">
  <div class="ds-input-wrap mb8">
    <span class="ds-input-label">Site Address (URL)</span>
    <div class="db-create-sub-site__address">
      <span *ngIf="!isSubDomain" class="mr10" [innerHTML]="parentUrl + '/'"></span>
      <input type="text" class="ds-input" maxlength="56"
             [class.error]="formSubmitted && subSiteForm?.get('subdomain')?.errors" formControlName="subdomain">
      <span *ngIf="isSubDomain" class="ml10" [innerHTML]="'.' + parentUrl"></span>
    </div>
    <span *ngIf="formSubmitted && subSiteForm?.get('subdomain')?.errors" class="ds-input-error-msg"
          [innerHTML]="subSiteForm?.get('subdomain')?.errors['required'] ?
            'This field is required.':
            subSiteForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) : ''"></span>
  </div>

  <div class="ds-input-wrap mb8">
    <span class="ds-input-label">Site title</span>
    <input type="text" class="ds-input" [class.error]="formSubmitted && subSiteForm?.get('title')?.errors"
           placeholder="Title" maxlength="255" formControlName="title">
    <span *ngIf="formSubmitted && subSiteForm?.get('title')?.errors" class="ds-input-error-msg"
          [innerHTML]="subSiteForm?.get('title')?.errors['required'] ? 'This field is required.' :
           subSiteForm?.get('title')?.errors?.title ? subSiteForm?.get('title')?.errors?.title : ''"></span>
  </div>

  <ds-dropdown dsDropdownLabel="Site Language" formControlName="language" [dsDropdownOptions]="languages"></ds-dropdown>

  <div class="ds-input-wrap mt28 mb8">
    <span class="ds-input-label">Admin email</span>
    <input type="text" class="ds-input" [class.error]="formSubmitted && subSiteForm?.get('email')?.errors"
           placeholder="Email" maxlength="255" formControlName="email">
    <span *ngIf="formSubmitted && subSiteForm?.get('email')?.errors" class="ds-input-error-msg"
          [innerHTML]="subSiteForm?.get('email')?.errors['required'] ? 'This field is required.'
          : subSiteForm.get('email').errors?.pattern ? ('text_invalidEmail' | dbText)
          : subSiteForm?.get('email')?.errors?.email ? subSiteForm?.get('email')?.errors?.email : ''"></span>
  </div>

  <p class="mb30">A new user will be created if the above email address is not in the database.<br class="ds-hide-mobile">
    The username and a link to set the password will be mailed to this email address.</p>

  <div class="text-right">
    <button class="ds-btn-blue" [ngClass]="{'ds-brn-disabled': loading}" type="submit">
      <span *ngIf="!loading">Add Site</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
</form>

